/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.0.0 (NJsonSchema v10.1.18.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const REGISTRY_API_BASE_URL = new InjectionToken<string>('REGISTRY_API_BASE_URL');

@Injectable()
export class RegistrationApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(REGISTRY_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    registerEmailSignups(): Observable<RegisterUsersResult> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/register-email-signups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterEmailSignups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterEmailSignups(<any>response_);
                } catch (e) {
                    return <Observable<RegisterUsersResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterUsersResult>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterEmailSignups(response: HttpResponseBase): Observable<RegisterUsersResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUsersResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterUsersResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerHighSchool(body: RegisterHighSchoolStudentsCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/register-high-school";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterHighSchool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterHighSchool(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterHighSchool(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userNameOreEmailAddress (optional) 
     * @return Success
     */
    isExistingUser(userNameOreEmailAddress: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/is-existing-user?";
        if (userNameOreEmailAddress !== undefined && userNameOreEmailAddress !== null)
            url_ += "userNameOreEmailAddress=" + encodeURIComponent("" + userNameOreEmailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsExistingUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExistingUser(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsExistingUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param program (optional) 
     * @return Success
     */
    getActiveCourses(program: string | null | undefined): Observable<CourseCatalogItem[]> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/get-active-courses?";
        if (program !== undefined && program !== null)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveCourses(<any>response_);
                } catch (e) {
                    return <Observable<CourseCatalogItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseCatalogItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveCourses(response: HttpResponseBase): Observable<CourseCatalogItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CourseCatalogItem.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseCatalogItem[]>(<any>null);
    }

    /**
     * @param courseRunId (optional) 
     * @return Success
     */
    getCourse(courseRunId: number | undefined): Observable<CourseCatalogItem> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/get-course?";
        if (courseRunId === null)
            throw new Error("The parameter 'courseRunId' cannot be null.");
        else if (courseRunId !== undefined)
            url_ += "courseRunId=" + encodeURIComponent("" + courseRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourse(<any>response_);
                } catch (e) {
                    return <Observable<CourseCatalogItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseCatalogItem>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourse(response: HttpResponseBase): Observable<CourseCatalogItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseCatalogItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseCatalogItem>(<any>null);
    }

    /**
     * @return Success
     */
    getSchools(): Observable<OptionValue[]> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/get-schools";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchools(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchools(<any>response_);
                } catch (e) {
                    return <Observable<OptionValue[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OptionValue[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSchools(response: HttpResponseBase): Observable<OptionValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OptionValue.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OptionValue[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSources(): Observable<OptionValue[]> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/get-sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSources(<any>response_);
                } catch (e) {
                    return <Observable<OptionValue[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OptionValue[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSources(response: HttpResponseBase): Observable<OptionValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OptionValue.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OptionValue[]>(<any>null);
    }

    /**
     * @return Success
     */
    updateAccessCode(): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/update-access-code";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccessCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccessCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAccessCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    verfiyAccessCode(): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/verfiy-access-code";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerfiyAccessCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerfiyAccessCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerfiyAccessCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetAccessCodes(body: ResetAccessCodesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/reset-access-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetAccessCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetAccessCodes(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetAccessCodes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @param searchText (optional) 
     * @param startDate (optional) 
     * @return Success
     */
    getRegistrations(courseId: number | undefined, searchText: string | null | undefined, startDate: moment.Moment | null | undefined): Observable<StudentRegistrationDto[]> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/get-registrations?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrations(<any>response_);
                } catch (e) {
                    return <Observable<StudentRegistrationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentRegistrationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrations(response: HttpResponseBase): Observable<StudentRegistrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StudentRegistrationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentRegistrationDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendEmail(body: ResendRegistrationEmailInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/resend-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendEmail(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processResendEmail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    checkAccessCode(): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/registry/registration/check-access-code";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccessCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccessCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckAccessCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class StaffApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(REGISTRY_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<StaffMemberInfo[]> {
        let url_ = this.baseUrl + "/api/studio/registry/staff/get-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<StaffMemberInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StaffMemberInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StaffMemberInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StaffMemberInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StaffMemberInfo[]>(<any>null);
    }

    /**
     * @param staffId (optional) 
     * @return Success
     */
    get(staffId: number | undefined): Observable<GetStaffDetailsOutput> {
        let url_ = this.baseUrl + "/api/studio/registry/staff/get?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GetStaffDetailsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStaffDetailsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetStaffDetailsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStaffDetailsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStaffDetailsOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateStaffInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/studio/registry/staff/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateStaffInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/registry/staff/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class StudentsApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(REGISTRY_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerStudent(body: RegisterStudentRequest | undefined): Observable<RegisterStudentResponse> {
        let url_ = this.baseUrl + "/api/studio/registry/students/register-student";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterStudent(<any>response_);
                } catch (e) {
                    return <Observable<RegisterStudentResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterStudentResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterStudent(response: HttpResponseBase): Observable<RegisterStudentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterStudentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterStudentResponse>(<any>null);
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    getStudents(search: string | null | undefined): Observable<StudentDto[]> {
        let url_ = this.baseUrl + "/api/studio/registry/students/get-students?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudents(<any>response_);
                } catch (e) {
                    return <Observable<StudentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStudents(response: HttpResponseBase): Observable<StudentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StudentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentDto[]>(<any>null);
    }

    /**
     * @param studentId (optional) 
     * @return Success
     */
    getStudent(studentId: number | undefined): Observable<StudentProfileDto> {
        let url_ = this.baseUrl + "/api/studio/registry/students/get-student?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudent(<any>response_);
                } catch (e) {
                    return <Observable<StudentProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStudent(response: HttpResponseBase): Observable<StudentProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentProfileDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStudent(body: UpdateStudentRequest | undefined): Observable<StudentDto> {
        let url_ = this.baseUrl + "/api/studio/registry/students/update-student";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStudent(<any>response_);
                } catch (e) {
                    return <Observable<StudentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStudent(response: HttpResponseBase): Observable<StudentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentDto>(<any>null);
    }

    /**
     * @param learnerId (optional) 
     * @return Success
     */
    removeLearnerProfile(learnerId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/studio/registry/students/remove-learner-profile?";
        if (learnerId === null)
            throw new Error("The parameter 'learnerId' cannot be null.");
        else if (learnerId !== undefined)
            url_ += "learnerId=" + encodeURIComponent("" + learnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLearnerProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLearnerProfile(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveLearnerProfile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getGrades(): Observable<GradeDto[]> {
        let url_ = this.baseUrl + "/api/studio/registry/students/get-grades";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGrades(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrades(<any>response_);
                } catch (e) {
                    return <Observable<GradeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GradeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGrades(response: HttpResponseBase): Observable<GradeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GradeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GradeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSchools(): Observable<SchoolDto[]> {
        let url_ = this.baseUrl + "/api/studio/registry/students/get-schools";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchools(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchools(<any>response_);
                } catch (e) {
                    return <Observable<SchoolDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SchoolDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSchools(response: HttpResponseBase): Observable<SchoolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SchoolDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SchoolDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enrollStudentToCourse(body: EnrollCourseRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/studio/registry/students/enroll-student-to-course";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnrollStudentToCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnrollStudentToCourse(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processEnrollStudentToCourse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class SubscriptionApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(REGISTRY_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param subscriptionId (optional) 
     * @return Success
     */
    getCourseSubscription(subscriptionId: string | undefined): Observable<CourseSubscriptionDto> {
        let url_ = this.baseUrl + "/api/studio/registry/subscription/get-course-subscription?";
        if (subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseSubscription(<any>response_);
                } catch (e) {
                    return <Observable<CourseSubscriptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseSubscriptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourseSubscription(response: HttpResponseBase): Observable<CourseSubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseSubscriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseSubscriptionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeAccess(body: ChangeSubscriptionAccessRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/registry/subscription/change-access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAccess(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    promote(body: PromoteStudentInput | undefined): Observable<CommandResultOfPromoteStudentOutput> {
        let url_ = this.baseUrl + "/api/studio/registry/subscription/promote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPromote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromote(<any>response_);
                } catch (e) {
                    return <Observable<CommandResultOfPromoteStudentOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommandResultOfPromoteStudentOutput>><any>_observableThrow(response_);
        }));
    }

    protected processPromote(response: HttpResponseBase): Observable<CommandResultOfPromoteStudentOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandResultOfPromoteStudentOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommandResultOfPromoteStudentOutput>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getCourseAccessLevels(courseId: number | undefined): Observable<SubscriptionLevelDto[]> {
        let url_ = this.baseUrl + "/api/studio/registry/subscription/get-course-access-levels?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseAccessLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseAccessLevels(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionLevelDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionLevelDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourseAccessLevels(response: HttpResponseBase): Observable<SubscriptionLevelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubscriptionLevelDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionLevelDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getActiveCourses(): Observable<ActiveCourseDto[]> {
        let url_ = this.baseUrl + "/api/studio/registry/subscription/get-active-courses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveCourses(<any>response_);
                } catch (e) {
                    return <Observable<ActiveCourseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActiveCourseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveCourses(response: HttpResponseBase): Observable<ActiveCourseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ActiveCourseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveCourseDto[]>(<any>null);
    }
}

export class RegisterUsersResult implements IRegisterUsersResult {
    usersRegistered: number;

    constructor(data?: IRegisterUsersResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersRegistered = _data["usersRegistered"];
        }
    }

    static fromJS(data: any): RegisterUsersResult {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUsersResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersRegistered"] = this.usersRegistered;
        return data; 
    }

    clone(): RegisterUsersResult {
        const json = this.toJSON();
        let result = new RegisterUsersResult();
        result.init(json);
        return result;
    }
}

export interface IRegisterUsersResult {
    usersRegistered: number;
}

export class RegisterHighSchoolStudentsCommand implements IRegisterHighSchoolStudentsCommand {
    userName: string | undefined;
    readonly id: string;

    constructor(data?: IRegisterHighSchoolStudentsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): RegisterHighSchoolStudentsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterHighSchoolStudentsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["id"] = this.id;
        return data; 
    }

    clone(): RegisterHighSchoolStudentsCommand {
        const json = this.toJSON();
        let result = new RegisterHighSchoolStudentsCommand();
        result.init(json);
        return result;
    }
}

export interface IRegisterHighSchoolStudentsCommand {
    userName: string | undefined;
    id: string;
}

export class CourseDetail implements ICourseDetail {
    description: string | undefined;
    requirements: string | undefined;
    classSchedule: string | undefined;
    year: string | undefined;
    grade: string | undefined;
    cost: string | undefined;
    whatsAppLink: string | undefined;
    program: string | undefined;

    constructor(data?: ICourseDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.requirements = _data["requirements"];
            this.classSchedule = _data["classSchedule"];
            this.year = _data["year"];
            this.grade = _data["grade"];
            this.cost = _data["cost"];
            this.whatsAppLink = _data["whatsAppLink"];
            this.program = _data["program"];
        }
    }

    static fromJS(data: any): CourseDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["requirements"] = this.requirements;
        data["classSchedule"] = this.classSchedule;
        data["year"] = this.year;
        data["grade"] = this.grade;
        data["cost"] = this.cost;
        data["whatsAppLink"] = this.whatsAppLink;
        data["program"] = this.program;
        return data; 
    }

    clone(): CourseDetail {
        const json = this.toJSON();
        let result = new CourseDetail();
        result.init(json);
        return result;
    }
}

export interface ICourseDetail {
    description: string | undefined;
    requirements: string | undefined;
    classSchedule: string | undefined;
    year: string | undefined;
    grade: string | undefined;
    cost: string | undefined;
    whatsAppLink: string | undefined;
    program: string | undefined;
}

export enum RunStatus {
    Scheduled = <any>"Scheduled",
    Started = <any>"Started",
    Completed = <any>"Completed",
}

export class CourseCatalogItem implements ICourseCatalogItem {
    id: number;
    name: string | undefined;
    startDate: moment.Moment | undefined;
    details: CourseDetail;
    isActive: boolean;
    isRegistrationOpen: boolean;
    status: RunStatus;
    defaultAccessLevelId: number;
    schoolYear: string | undefined;
    program: string | undefined;

    constructor(data?: ICourseCatalogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.details = _data["details"] ? CourseDetail.fromJS(_data["details"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isRegistrationOpen = _data["isRegistrationOpen"];
            this.status = _data["status"];
            this.defaultAccessLevelId = _data["defaultAccessLevelId"];
            this.schoolYear = _data["schoolYear"];
            this.program = _data["program"];
        }
    }

    static fromJS(data: any): CourseCatalogItem {
        data = typeof data === 'object' ? data : {};
        let result = new CourseCatalogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isRegistrationOpen"] = this.isRegistrationOpen;
        data["status"] = this.status;
        data["defaultAccessLevelId"] = this.defaultAccessLevelId;
        data["schoolYear"] = this.schoolYear;
        data["program"] = this.program;
        return data; 
    }

    clone(): CourseCatalogItem {
        const json = this.toJSON();
        let result = new CourseCatalogItem();
        result.init(json);
        return result;
    }
}

export interface ICourseCatalogItem {
    id: number;
    name: string | undefined;
    startDate: moment.Moment | undefined;
    details: CourseDetail;
    isActive: boolean;
    isRegistrationOpen: boolean;
    status: RunStatus;
    defaultAccessLevelId: number;
    schoolYear: string | undefined;
    program: string | undefined;
}

export class OptionValue implements IOptionValue {
    category: string | undefined;
    value: string | undefined;
    label: string | undefined;

    constructor(data?: IOptionValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): OptionValue {
        data = typeof data === 'object' ? data : {};
        let result = new OptionValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["value"] = this.value;
        data["label"] = this.label;
        return data; 
    }

    clone(): OptionValue {
        const json = this.toJSON();
        let result = new OptionValue();
        result.init(json);
        return result;
    }
}

export interface IOptionValue {
    category: string | undefined;
    value: string | undefined;
    label: string | undefined;
}

export class ResetAccessCodesInput implements IResetAccessCodesInput {
    courseId: number;
    userId: number | undefined;
    readonly id: string;

    constructor(data?: IResetAccessCodesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.userId = _data["userId"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): ResetAccessCodesInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAccessCodesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ResetAccessCodesInput {
        const json = this.toJSON();
        let result = new ResetAccessCodesInput();
        result.init(json);
        return result;
    }
}

export interface IResetAccessCodesInput {
    courseId: number;
    userId: number | undefined;
    id: string;
}

export class StudentRegistrationDto implements IStudentRegistrationDto {
    readonly studentFullName: string | undefined;
    studentFirstName: string | undefined;
    studentLastName: string | undefined;
    userName: string | undefined;
    studentEmail: string | undefined;
    studentPassCode: string | undefined;
    readonly parentFullName: string | undefined;
    parentFirstName: string | undefined;
    parentLastName: string | undefined;
    parentEmailAddress: string | undefined;
    parentPhone: string | undefined;
    heardAbout: string | undefined;
    school: string | undefined;
    otherSchool: string | undefined;
    studentSchool: string | undefined;
    registeredDate: moment.Moment;
    readonly registeredDateText: string | undefined;
    course: string | undefined;
    grade: string | undefined;

    constructor(data?: IStudentRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).studentFullName = _data["studentFullName"];
            this.studentFirstName = _data["studentFirstName"];
            this.studentLastName = _data["studentLastName"];
            this.userName = _data["userName"];
            this.studentEmail = _data["studentEmail"];
            this.studentPassCode = _data["studentPassCode"];
            (<any>this).parentFullName = _data["parentFullName"];
            this.parentFirstName = _data["parentFirstName"];
            this.parentLastName = _data["parentLastName"];
            this.parentEmailAddress = _data["parentEmailAddress"];
            this.parentPhone = _data["parentPhone"];
            this.heardAbout = _data["heardAbout"];
            this.school = _data["school"];
            this.otherSchool = _data["otherSchool"];
            this.studentSchool = _data["studentSchool"];
            this.registeredDate = _data["registeredDate"] ? moment(_data["registeredDate"].toString()) : <any>undefined;
            (<any>this).registeredDateText = _data["registeredDateText"];
            this.course = _data["course"];
            this.grade = _data["grade"];
        }
    }

    static fromJS(data: any): StudentRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentFullName"] = this.studentFullName;
        data["studentFirstName"] = this.studentFirstName;
        data["studentLastName"] = this.studentLastName;
        data["userName"] = this.userName;
        data["studentEmail"] = this.studentEmail;
        data["studentPassCode"] = this.studentPassCode;
        data["parentFullName"] = this.parentFullName;
        data["parentFirstName"] = this.parentFirstName;
        data["parentLastName"] = this.parentLastName;
        data["parentEmailAddress"] = this.parentEmailAddress;
        data["parentPhone"] = this.parentPhone;
        data["heardAbout"] = this.heardAbout;
        data["school"] = this.school;
        data["otherSchool"] = this.otherSchool;
        data["studentSchool"] = this.studentSchool;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["registeredDateText"] = this.registeredDateText;
        data["course"] = this.course;
        data["grade"] = this.grade;
        return data; 
    }

    clone(): StudentRegistrationDto {
        const json = this.toJSON();
        let result = new StudentRegistrationDto();
        result.init(json);
        return result;
    }
}

export interface IStudentRegistrationDto {
    studentFullName: string | undefined;
    studentFirstName: string | undefined;
    studentLastName: string | undefined;
    userName: string | undefined;
    studentEmail: string | undefined;
    studentPassCode: string | undefined;
    parentFullName: string | undefined;
    parentFirstName: string | undefined;
    parentLastName: string | undefined;
    parentEmailAddress: string | undefined;
    parentPhone: string | undefined;
    heardAbout: string | undefined;
    school: string | undefined;
    otherSchool: string | undefined;
    studentSchool: string | undefined;
    registeredDate: moment.Moment;
    registeredDateText: string | undefined;
    course: string | undefined;
    grade: string | undefined;
}

export class ResendRegistrationEmailInput implements IResendRegistrationEmailInput {
    studentId: number;
    courseId: number;
    cc: string | undefined;
    readonly id: string;

    constructor(data?: IResendRegistrationEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.courseId = _data["courseId"];
            this.cc = _data["cc"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): ResendRegistrationEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResendRegistrationEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["courseId"] = this.courseId;
        data["cc"] = this.cc;
        data["id"] = this.id;
        return data; 
    }

    clone(): ResendRegistrationEmailInput {
        const json = this.toJSON();
        let result = new ResendRegistrationEmailInput();
        result.init(json);
        return result;
    }
}

export interface IResendRegistrationEmailInput {
    studentId: number;
    courseId: number;
    cc: string | undefined;
    id: string;
}

export class StaffMemberInfo implements IStaffMemberInfo {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    userName: string | undefined;
    readonly fullName: string | undefined;

    constructor(data?: IStaffMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): StaffMemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        return data; 
    }

    clone(): StaffMemberInfo {
        const json = this.toJSON();
        let result = new StaffMemberInfo();
        result.init(json);
        return result;
    }
}

export interface IStaffMemberInfo {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    userName: string | undefined;
    fullName: string | undefined;
}

export class StaffMemberModel implements IStaffMemberModel {
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    userName: string | undefined;
    assignedCourses: number[] | undefined;
    roles: string[] | undefined;

    constructor(data?: IStaffMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["assignedCourses"])) {
                this.assignedCourses = [] as any;
                for (let item of _data["assignedCourses"])
                    this.assignedCourses.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
        }
    }

    static fromJS(data: any): StaffMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        if (Array.isArray(this.assignedCourses)) {
            data["assignedCourses"] = [];
            for (let item of this.assignedCourses)
                data["assignedCourses"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data; 
    }

    clone(): StaffMemberModel {
        const json = this.toJSON();
        let result = new StaffMemberModel();
        result.init(json);
        return result;
    }
}

export interface IStaffMemberModel {
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    userName: string | undefined;
    assignedCourses: number[] | undefined;
    roles: string[] | undefined;
}

export class GetStaffDetailsOutput implements IGetStaffDetailsOutput {
    member: StaffMemberModel;

    constructor(data?: IGetStaffDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.member = _data["member"] ? StaffMemberModel.fromJS(_data["member"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetStaffDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStaffDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetStaffDetailsOutput {
        const json = this.toJSON();
        let result = new GetStaffDetailsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetStaffDetailsOutput {
    member: StaffMemberModel;
}

export class CreateStaffInput implements ICreateStaffInput {
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    userName: string | undefined;
    password: string | undefined;
    assignedCourses: number[] | undefined;
    roles: string[] | undefined;

    constructor(data?: ICreateStaffInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            if (Array.isArray(_data["assignedCourses"])) {
                this.assignedCourses = [] as any;
                for (let item of _data["assignedCourses"])
                    this.assignedCourses.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
        }
    }

    static fromJS(data: any): CreateStaffInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["password"] = this.password;
        if (Array.isArray(this.assignedCourses)) {
            data["assignedCourses"] = [];
            for (let item of this.assignedCourses)
                data["assignedCourses"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data; 
    }

    clone(): CreateStaffInput {
        const json = this.toJSON();
        let result = new CreateStaffInput();
        result.init(json);
        return result;
    }
}

export interface ICreateStaffInput {
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    userName: string | undefined;
    password: string | undefined;
    assignedCourses: number[] | undefined;
    roles: string[] | undefined;
}

export class UpdateStaffInput implements IUpdateStaffInput {
    staffId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    userName: string | undefined;
    assignedCourses: number[] | undefined;
    roles: string[] | undefined;

    constructor(data?: IUpdateStaffInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffId = _data["staffId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["assignedCourses"])) {
                this.assignedCourses = [] as any;
                for (let item of _data["assignedCourses"])
                    this.assignedCourses.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateStaffInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        if (Array.isArray(this.assignedCourses)) {
            data["assignedCourses"] = [];
            for (let item of this.assignedCourses)
                data["assignedCourses"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data; 
    }

    clone(): UpdateStaffInput {
        const json = this.toJSON();
        let result = new UpdateStaffInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateStaffInput {
    staffId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    userName: string | undefined;
    assignedCourses: number[] | undefined;
    roles: string[] | undefined;
}

export enum GenderKind {
    Female = <any>"Female",
    Male = <any>"Male",
}

export class RegisterStudentRequest implements IRegisterStudentRequest {
    emailAddress: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    school: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: GenderKind;
    passCode: string | undefined;
    grade: string | undefined;
    parentGuardianName: string | undefined;
    parentGuardianEmail: string | undefined;

    constructor(data?: IRegisterStudentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.school = _data["school"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.passCode = _data["passCode"];
            this.grade = _data["grade"];
            this.parentGuardianName = _data["parentGuardianName"];
            this.parentGuardianEmail = _data["parentGuardianEmail"];
        }
    }

    static fromJS(data: any): RegisterStudentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterStudentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["school"] = this.school;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["passCode"] = this.passCode;
        data["grade"] = this.grade;
        data["parentGuardianName"] = this.parentGuardianName;
        data["parentGuardianEmail"] = this.parentGuardianEmail;
        return data; 
    }

    clone(): RegisterStudentRequest {
        const json = this.toJSON();
        let result = new RegisterStudentRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterStudentRequest {
    emailAddress: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    school: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    gender: GenderKind;
    passCode: string | undefined;
    grade: string | undefined;
    parentGuardianName: string | undefined;
    parentGuardianEmail: string | undefined;
}

export class RegisterStudentResponse implements IRegisterStudentResponse {
    registrationId: string;
    learnerId: number;

    constructor(data?: IRegisterStudentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.learnerId = _data["learnerId"];
        }
    }

    static fromJS(data: any): RegisterStudentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterStudentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["learnerId"] = this.learnerId;
        return data; 
    }

    clone(): RegisterStudentResponse {
        const json = this.toJSON();
        let result = new RegisterStudentResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterStudentResponse {
    registrationId: string;
    learnerId: number;
}

export enum RegistrationStatusKind {
    Active = <any>"Active",
    Cancelled = <any>"Cancelled",
    Suspended = <any>"Suspended",
    Deleted = <any>"Deleted",
}

export class StudentDto implements IStudentDto {
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    school: string | undefined;
    status: RegistrationStatusKind;
    accessCode: string | undefined;
    gender: string | undefined;
    grade: string | undefined;
    parentGuardianName: string | undefined;
    parentGuardianEmail: string | undefined;
    readonly fullName: string | undefined;
    readonly initial: string | undefined;
    id: number;

    constructor(data?: IStudentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.school = _data["school"];
            this.status = _data["status"];
            this.accessCode = _data["accessCode"];
            this.gender = _data["gender"];
            this.grade = _data["grade"];
            this.parentGuardianName = _data["parentGuardianName"];
            this.parentGuardianEmail = _data["parentGuardianEmail"];
            (<any>this).fullName = _data["fullName"];
            (<any>this).initial = _data["initial"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StudentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["school"] = this.school;
        data["status"] = this.status;
        data["accessCode"] = this.accessCode;
        data["gender"] = this.gender;
        data["grade"] = this.grade;
        data["parentGuardianName"] = this.parentGuardianName;
        data["parentGuardianEmail"] = this.parentGuardianEmail;
        data["fullName"] = this.fullName;
        data["initial"] = this.initial;
        data["id"] = this.id;
        return data; 
    }

    clone(): StudentDto {
        const json = this.toJSON();
        let result = new StudentDto();
        result.init(json);
        return result;
    }
}

export interface IStudentDto {
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    school: string | undefined;
    status: RegistrationStatusKind;
    accessCode: string | undefined;
    gender: string | undefined;
    grade: string | undefined;
    parentGuardianName: string | undefined;
    parentGuardianEmail: string | undefined;
    fullName: string | undefined;
    initial: string | undefined;
    id: number;
}

export enum AccessModeKind {
    Preview = <any>"Preview",
    Full = <any>"Full",
}

export class CourseEnrollmentDto implements ICourseEnrollmentDto {
    courseEnrollmentId: number;
    courseId: number;
    studentId: number;
    courseName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    status: RegistrationStatusKind;
    courseAccess: AccessModeKind;

    constructor(data?: ICourseEnrollmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseEnrollmentId = _data["courseEnrollmentId"];
            this.courseId = _data["courseId"];
            this.studentId = _data["studentId"];
            this.courseName = _data["courseName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.courseAccess = _data["courseAccess"];
        }
    }

    static fromJS(data: any): CourseEnrollmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseEnrollmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseEnrollmentId"] = this.courseEnrollmentId;
        data["courseId"] = this.courseId;
        data["studentId"] = this.studentId;
        data["courseName"] = this.courseName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["courseAccess"] = this.courseAccess;
        return data; 
    }

    clone(): CourseEnrollmentDto {
        const json = this.toJSON();
        let result = new CourseEnrollmentDto();
        result.init(json);
        return result;
    }
}

export interface ICourseEnrollmentDto {
    courseEnrollmentId: number;
    courseId: number;
    studentId: number;
    courseName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    status: RegistrationStatusKind;
    courseAccess: AccessModeKind;
}

export class StudentProfileDto implements IStudentProfileDto {
    student: StudentDto;
    enrolledCourses: CourseEnrollmentDto[] | undefined;

    constructor(data?: IStudentProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.student = _data["student"] ? StudentDto.fromJS(_data["student"]) : <any>undefined;
            if (Array.isArray(_data["enrolledCourses"])) {
                this.enrolledCourses = [] as any;
                for (let item of _data["enrolledCourses"])
                    this.enrolledCourses.push(CourseEnrollmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        if (Array.isArray(this.enrolledCourses)) {
            data["enrolledCourses"] = [];
            for (let item of this.enrolledCourses)
                data["enrolledCourses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StudentProfileDto {
        const json = this.toJSON();
        let result = new StudentProfileDto();
        result.init(json);
        return result;
    }
}

export interface IStudentProfileDto {
    student: StudentDto;
    enrolledCourses: CourseEnrollmentDto[] | undefined;
}

export class UpdateStudentRequest implements IUpdateStudentRequest {
    id: number;
    emailAddress: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    school: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    statusKind: RegistrationStatusKind;

    constructor(data?: IUpdateStudentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.school = _data["school"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.statusKind = _data["statusKind"];
        }
    }

    static fromJS(data: any): UpdateStudentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["school"] = this.school;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["statusKind"] = this.statusKind;
        return data; 
    }

    clone(): UpdateStudentRequest {
        const json = this.toJSON();
        let result = new UpdateStudentRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentRequest {
    id: number;
    emailAddress: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    school: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    statusKind: RegistrationStatusKind;
}

export class GradeDto implements IGradeDto {
    name: string | undefined;
    id: number;

    constructor(data?: IGradeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GradeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GradeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): GradeDto {
        const json = this.toJSON();
        let result = new GradeDto();
        result.init(json);
        return result;
    }
}

export interface IGradeDto {
    name: string | undefined;
    id: number;
}

export class SchoolDto implements ISchoolDto {
    schoolName: string | undefined;
    status: string | undefined;
    id: number;

    constructor(data?: ISchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schoolName = _data["schoolName"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolName"] = this.schoolName;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }

    clone(): SchoolDto {
        const json = this.toJSON();
        let result = new SchoolDto();
        result.init(json);
        return result;
    }
}

export interface ISchoolDto {
    schoolName: string | undefined;
    status: string | undefined;
    id: number;
}

export enum SubscriptionStatusKind {
    Active = <any>"Active",
    Trial = <any>"Trial",
    TrialExpired = <any>"TrialExpired",
    Expired = <any>"Expired",
    Cancelled = <any>"Cancelled",
    InActive = <any>"InActive",
    Completed = <any>"Completed",
    Preview = <any>"Preview",
}

export class EnrollCourseRequest implements IEnrollCourseRequest {
    studentId: number;
    courseId: number;
    accessLevel: AccessModeKind;
    status: SubscriptionStatusKind;
    startDate: moment.Moment;

    constructor(data?: IEnrollCourseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.courseId = _data["courseId"];
            this.accessLevel = _data["accessLevel"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EnrollCourseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollCourseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["courseId"] = this.courseId;
        data["accessLevel"] = this.accessLevel;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): EnrollCourseRequest {
        const json = this.toJSON();
        let result = new EnrollCourseRequest();
        result.init(json);
        return result;
    }
}

export interface IEnrollCourseRequest {
    studentId: number;
    courseId: number;
    accessLevel: AccessModeKind;
    status: SubscriptionStatusKind;
    startDate: moment.Moment;
}

export class CourseSubscriptionDto implements ICourseSubscriptionDto {
    subscriptionId: string;
    courseId: number;
    course: string | undefined;
    studentId: string | undefined;
    student: string | undefined;
    accessLevelId: number;
    accessLevel: string | undefined;
    status: SubscriptionStatusKind;
    startDate: moment.Moment | undefined;
    currentStartDate: moment.Moment | undefined;
    currentExpiryDate: moment.Moment | undefined;

    constructor(data?: ICourseSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.courseId = _data["courseId"];
            this.course = _data["course"];
            this.studentId = _data["studentId"];
            this.student = _data["student"];
            this.accessLevelId = _data["accessLevelId"];
            this.accessLevel = _data["accessLevel"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.currentStartDate = _data["currentStartDate"] ? moment(_data["currentStartDate"].toString()) : <any>undefined;
            this.currentExpiryDate = _data["currentExpiryDate"] ? moment(_data["currentExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["courseId"] = this.courseId;
        data["course"] = this.course;
        data["studentId"] = this.studentId;
        data["student"] = this.student;
        data["accessLevelId"] = this.accessLevelId;
        data["accessLevel"] = this.accessLevel;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["currentStartDate"] = this.currentStartDate ? this.currentStartDate.toISOString() : <any>undefined;
        data["currentExpiryDate"] = this.currentExpiryDate ? this.currentExpiryDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): CourseSubscriptionDto {
        const json = this.toJSON();
        let result = new CourseSubscriptionDto();
        result.init(json);
        return result;
    }
}

export interface ICourseSubscriptionDto {
    subscriptionId: string;
    courseId: number;
    course: string | undefined;
    studentId: string | undefined;
    student: string | undefined;
    accessLevelId: number;
    accessLevel: string | undefined;
    status: SubscriptionStatusKind;
    startDate: moment.Moment | undefined;
    currentStartDate: moment.Moment | undefined;
    currentExpiryDate: moment.Moment | undefined;
}

export class ChangeSubscriptionAccessRequest implements IChangeSubscriptionAccessRequest {
    subscriptionId: string;
    accessLevelId: number;
    status: SubscriptionStatusKind;
    courseId: number;

    constructor(data?: IChangeSubscriptionAccessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.accessLevelId = _data["accessLevelId"];
            this.status = _data["status"];
            this.courseId = _data["courseId"];
        }
    }

    static fromJS(data: any): ChangeSubscriptionAccessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSubscriptionAccessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["accessLevelId"] = this.accessLevelId;
        data["status"] = this.status;
        data["courseId"] = this.courseId;
        return data; 
    }

    clone(): ChangeSubscriptionAccessRequest {
        const json = this.toJSON();
        let result = new ChangeSubscriptionAccessRequest();
        result.init(json);
        return result;
    }
}

export interface IChangeSubscriptionAccessRequest {
    subscriptionId: string;
    accessLevelId: number;
    status: SubscriptionStatusKind;
    courseId: number;
}

export class PromoteStudentInput implements IPromoteStudentInput {
    studentUserId: number;
    courseId: number;
    readonly id: string;

    constructor(data?: IPromoteStudentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentUserId = _data["studentUserId"];
            this.courseId = _data["courseId"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): PromoteStudentInput {
        data = typeof data === 'object' ? data : {};
        let result = new PromoteStudentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentUserId"] = this.studentUserId;
        data["courseId"] = this.courseId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PromoteStudentInput {
        const json = this.toJSON();
        let result = new PromoteStudentInput();
        result.init(json);
        return result;
    }
}

export interface IPromoteStudentInput {
    studentUserId: number;
    courseId: number;
    id: string;
}

export class PromoteStudentOutput implements IPromoteStudentOutput {
    registrationId: string;
    subscriptionId: string;

    constructor(data?: IPromoteStudentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): PromoteStudentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PromoteStudentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["subscriptionId"] = this.subscriptionId;
        return data; 
    }

    clone(): PromoteStudentOutput {
        const json = this.toJSON();
        let result = new PromoteStudentOutput();
        result.init(json);
        return result;
    }
}

export interface IPromoteStudentOutput {
    registrationId: string;
    subscriptionId: string;
}

export class ICommandError implements IICommandError {
    readonly code: string | undefined;
    readonly description: string | undefined;

    constructor(data?: IICommandError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).code = _data["code"];
            (<any>this).description = _data["description"];
        }
    }

    static fromJS(data: any): ICommandError {
        data = typeof data === 'object' ? data : {};
        let result = new ICommandError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }

    clone(): ICommandError {
        const json = this.toJSON();
        let result = new ICommandError();
        result.init(json);
        return result;
    }
}

export interface IICommandError {
    code: string | undefined;
    description: string | undefined;
}

export class CommandResultOfPromoteStudentOutput implements ICommandResultOfPromoteStudentOutput {
    value: PromoteStudentOutput;
    readonly isSuccessful: boolean;
    readonly hasErrors: boolean;
    readonly errors: ICommandError[] | undefined;
    readonly friendlyErrorMessage: string | undefined;

    constructor(data?: ICommandResultOfPromoteStudentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? PromoteStudentOutput.fromJS(_data["value"]) : <any>undefined;
            (<any>this).isSuccessful = _data["isSuccessful"];
            (<any>this).hasErrors = _data["hasErrors"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors.push(ICommandError.fromJS(item));
            }
            (<any>this).friendlyErrorMessage = _data["friendlyErrorMessage"];
        }
    }

    static fromJS(data: any): CommandResultOfPromoteStudentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommandResultOfPromoteStudentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["isSuccessful"] = this.isSuccessful;
        data["hasErrors"] = this.hasErrors;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["friendlyErrorMessage"] = this.friendlyErrorMessage;
        return data; 
    }

    clone(): CommandResultOfPromoteStudentOutput {
        const json = this.toJSON();
        let result = new CommandResultOfPromoteStudentOutput();
        result.init(json);
        return result;
    }
}

export interface ICommandResultOfPromoteStudentOutput {
    value: PromoteStudentOutput;
    isSuccessful: boolean;
    hasErrors: boolean;
    errors: ICommandError[] | undefined;
    friendlyErrorMessage: string | undefined;
}

export class SubscriptionLevelDto implements ISubscriptionLevelDto {
    courseId: number;
    name: string | undefined;
    description: string | undefined;
    isDefault: boolean;
    id: number;

    constructor(data?: ISubscriptionLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data; 
    }

    clone(): SubscriptionLevelDto {
        const json = this.toJSON();
        let result = new SubscriptionLevelDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionLevelDto {
    courseId: number;
    name: string | undefined;
    description: string | undefined;
    isDefault: boolean;
    id: number;
}

export class ActiveCourseDto implements IActiveCourseDto {
    name: string | undefined;
    description: string | undefined;
    accessLevels: SubscriptionLevelDto[] | undefined;
    id: number;

    constructor(data?: IActiveCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["accessLevels"])) {
                this.accessLevels = [] as any;
                for (let item of _data["accessLevels"])
                    this.accessLevels.push(SubscriptionLevelDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActiveCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.accessLevels)) {
            data["accessLevels"] = [];
            for (let item of this.accessLevels)
                data["accessLevels"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): ActiveCourseDto {
        const json = this.toJSON();
        let result = new ActiveCourseDto();
        result.init(json);
        return result;
    }
}

export interface IActiveCourseDto {
    name: string | undefined;
    description: string | undefined;
    accessLevels: SubscriptionLevelDto[] | undefined;
    id: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}